
import React, { useMemo } from "react";
import useFetchUnprocessed from "../../../Hooks/qlp_ddpcr/useFetchUnprocessed";
import { formatBytes } from "../../../../utils/basic";
import { DataGrid, GridToolbar } from "@material-ui/data-grid";



const QlpListUnprocessed = () => {

  const fileType = "qlp";

  const qlpQuery = useFetchUnprocessed(fileType);
  const qlpData = qlpQuery?.isSuccess ? qlpQuery.data.data : null;

  const dataForTable = (qlpData) => qlpData?.map(item => {
    let properties = {
      "id": crypto.randomUUID(),
      "fileName": item.Key.split('/')[2],
      "lastModified": new Date(item.LastModified).toLocaleDateString(),
      "size": formatBytes(item.Size),
      "Size": item.Size
    };
    return properties;
  });


  const data = useMemo(() => {
    return dataForTable(qlpData);
  }, [qlpData]);

  const cols = [
    {
      field: 'fileName',
      headerName: 'File Name',
      description: 'Name of the File',
      width: 450
    },
    {
      field: 'lastModified',
      headerName: 'Last Modified',
      description: 'last modified date time',
      width: 450
    },
    {
      field: 'size',
      headerName: 'Size',
      description: 'File Size',
      width: 450
    }
  ];


  return (
    <>
      <h5>QLP Data</h5>

      {/* {qlpData?.length > 0 && <Table columns={columns} data={data} />} */}

      <div style={{ height: 400, width: '100%' }}>
        {qlpData?.length > 0 ? <DataGrid columns={cols} rows={data} components={{
          Toolbar: GridToolbar
        }}>
        </DataGrid> :
          <span> No UnProcessed files...  </span>}
      </div>


    </>
  )
}

export default QlpListUnprocessed;
